import Check from '@mui/icons-material/Check';
import Close from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';

/** A tick or a cross for a yes/no value - used everywhere a boolean is shown,
 * instead of the words "Yes"/"No". Matches the DataGrid's own boolean cells
 * (same icons and colours), so a value reads the same in a list and on a
 * detail page. The words stay as the icon's accessible title. */
export const BooleanIcon = ({ value }: { value: boolean }) => {
  const { t } = useTranslation();
  const label = value ? t('Yes') : t('No');
  const Icon = value ? Check : Close;

  return (
    <Icon
      fontSize="small"
      titleAccess={label}
      sx={{ color: value ? 'text.secondary' : 'text.disabled', verticalAlign: 'middle' }}
    />
  );
};
